import React from 'react'

type Props = {
  iconSize?: number
  className?: string
}

const AppStoreIcon = ({ iconSize = 24, className }: Props) => {
  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0744 1.64844C13.1852 2.60594 12.7869 3.54844 12.2027 4.24177C11.5944 4.92427 10.6194 5.44594 9.67186 5.37844C9.54686 4.45844 10.0285 3.47844 10.566 2.88177C11.1744 2.2026 12.2302 1.68344 13.0744 1.64844ZM16.1077 6.7901C15.9952 6.85344 14.2485 7.84844 14.2677 9.8726C14.2894 12.3226 16.5235 13.1326 16.5502 13.1409C16.5377 13.1984 16.2002 14.3101 15.3635 15.4384C14.6635 16.4326 13.9302 17.4043 12.7669 17.4218C12.2127 17.4334 11.8394 17.2818 11.4502 17.1243C11.0435 16.9601 10.6202 16.7893 9.95853 16.7893C9.25603 16.7893 8.81353 16.9659 8.38686 17.1359C8.01853 17.2834 7.66186 17.4268 7.15853 17.4459C6.0502 17.4851 5.2027 16.3851 4.4777 15.4009C3.02936 13.3901 1.90103 9.73427 3.41353 7.24594C4.14686 6.02594 5.48353 5.24094 6.91103 5.21927C7.5402 5.2076 8.14436 5.4376 8.6727 5.63927C9.07686 5.79427 9.4377 5.93094 9.73353 5.93094C9.99353 5.93094 10.3444 5.79927 10.7535 5.6451C11.3977 5.4026 12.1869 5.1051 12.9894 5.1851C13.5385 5.2001 15.1027 5.39094 16.1102 6.78844L16.1077 6.7901Z"
        fill="white"
      />
    </svg>
  )
}

export default AppStoreIcon
